import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { CardsActions } from '../../paymentMethods/cards/cardsActions';
import { AddressesActions } from '../addressesActions';
import { CardFormatterService } from '../../paymentMethods/cards/card/cardFormatter.service';
import AddressList from './AddressList';

function mapStateToProps(state: IReduxRootState) {
    const maxNumberOfAddress = 100;
    const { addressesMap, formOpen, loading } = state.addresses;
    const { cardsMap } = state.cards;
    const addresses = addressesMap ? Object.values(addressesMap) : [];
    const addressCards: { [key: string]: string[] } = {};

    if (addresses && cardsMap) {
        Object.values(cardsMap).forEach((card) => {
            if (card.addressUuid && card.cardToken) {
                if (!addressCards[card.addressUuid]) {
                    addressCards[card.addressUuid] = [];
                }
                addressCards[card.addressUuid].push(
                    CardFormatterService.addSpaces(`************${card.numberLast}`, [4, 4, 4, 4]),
                );
            }
        });
    }

    return {
        maxNumberOfAddress,
        addressCards,
        addresses,
        formOpen,
        loading,
        challengerPid: state.app.appConfig.CHALLENGER_PIDS.ADDRESS ?? '',
        challengerPidDefault: state.app.appConfig.CHALLENGER_PIDS.ADDRESS_DEFAULT ?? '',
        locale: state.app.locale,
    };
}

function mapDispatchToProps(dispatch: Dispatch<Action>) {
    return {
        getAddresses: () => {
            dispatch(AddressesActions.getAddresses());
            dispatch(CardsActions.getCards());
        },
        closeOverlay: () => {
            dispatch(AddressesActions.closeForm());
        },
        openOverlay: () => {
            dispatch(AddressesActions.openForm());
        },
    };
}

const AddressListContainer = connect(mapStateToProps, mapDispatchToProps)(AddressList);

export default AddressListContainer;
